import request from '@/utils/request';

// 订单列表
export const orderList = (data: any): any =>
  request({
    url: '/order/backend/list',
    data: data
  })

// 订单详情
export const orderInfo = (data: any): any =>
  request({
    url: '/order/backend/info',
    data: data
  })

//订单审核人流程
export const orderCheck = (data: any): any =>
  request({
    url: '/order/check/detaillist',
    data: data
  })

// 代理订单
export const agencyOrderList = (data: any): any =>
  request({
    url: '/order/check/detaillist',
    data: data
  })

// 代理订单_待审核订单
export const getAgentCheckOrderList = (data: any): any =>
  request({
    url: '/order/check/orderlist',
    data: data
  })

//公司审核订单
export const checkBackendAgentOrder = (data: any): any =>
  request({
    url: '/order/check/order',
    data: data
  })

// 供应商_订单列表_销售订单
export const getProviderSalesOrderList = (data: any): any =>
  request({
    url: '/provider/order/sellOrderByProductList',
    data
  })

// 供应商_订单列表_查看详情
export const getProviderProductOrderList = (data: any): any =>
  request({
    url: '/provider/order/sellOrderDetailList',
    data
  })

//产品订单
export const getAgentProductOrderList = (data: any): any =>
  request({
    url: '/order/product/list',
    data: data
  })
//产品订单
export const orderSendImportRecordList = (data: any): any =>
  request({
    url: '/provider/order/orderSendImportRecordList',
    data: data
  })


// 查看物流
export const lookExpress = (data: any): any =>
request({
  url: '/provider/order/lookExpress',
  data: data
})

// 散单物流-列表
export const orderOuterlist = (data: any): any =>
request({
  url: '/provider/orderOuter/list',
  data: data
})
// 散单物流-导入
export const orderOuterimport = (data: any): any =>
request({
  url: '/provider/orderOuter/import',
  data: data
})
// 散单物流-导入状态
export const orderOuterimportState = (data: any): any =>
request({
  url: '/provider/orderOuter/importState',
  data: data
})
// 散单物流-导入下载
export const orderOuterimportDownload = (data: any): any =>
request({
  url: '/provider/orderOuter/importDownload',
  data: data
})
// 散单物流-修改
export const orderOutermodify = (data: any): any =>
request({
  url: '/provider/orderOuter/modify',
  data: data
})
// 散单物流-删除
export const orderOuterdelete = (data: any): any =>
request({
  url: '/provider/orderOuter/delete',
  data: data
})


// 商品结算
export const productSettlementlist = (data: any): any =>
request({
	url: '/provider/order/productSettlement/list',
	data: data
})






// 财务-订单结算-未结算列表
export const orderSettleunsettledlist = (data: any): any =>
request({
	url: '/provider/finance/orderSettle/unsettled/list',
	data: data
})
// 财务-订单结算-审核中已结算列表
export const orderSettlerecordlist = (data: any): any =>
request({
	url: '/provider/finance/orderSettle/record/list',
	data: data
})
// 财务-订单结算-结算首款验证
export const orderSettlesettleFirstverify = (data: any): any =>
request({
	url: '/provider/finance/orderSettle/settleFirst/verify',
	data: data
})
// 财务-订单结算-结算首款未签收订单列表
export const orderSettlesettleFirstunsignedOrderDetailList = (data: any): any =>
request({
	url: '/provider/finance/orderSettle/settleFirst/unsignedOrderDetailList',
	data: data
})
// 财务-订单结算-结算首款信息
export const orderSettlesettleFirstinfo = (data: any): any =>
request({
	url: '/provider/finance/orderSettle/settleFirst/info',
	data: data
})
// 财务-订单结算-结算首款
export const orderSettlesettleFirst = (data: any): any =>
request({
	url: '/provider/finance/orderSettle/settleFirst',
	data: data
})
// 财务-订单结算-结算尾款信息
export const orderSettlesettleLastinfo = (data: any): any =>
request({
	url: '/provider/finance/orderSettle/settleLast/info',
	data: data
})
// 财务-订单结算-结算尾款
export const orderSettlesettleLast = (data: any): any =>
request({
	url: '/provider/finance/orderSettle/settleLast',
	data: data
})
// 财务-订单结算-订单明细列表
export const orderSettleorderDetailList = (data: any): any =>
request({
	url: '/provider/finance/orderSettle/orderDetailList',
	data: data
})

// 财务-订单结算-明细导出-参数缓存 
export const orderSettledetailexportparamCache = (data: any): any =>
request({
	url: '/provider/finance/orderSettle/detail/export/paramCache',
	data: data
})



// 供应商-财务-订单结算-结算时间
export const orderSettlesettleTime = (data: any): any =>
request({
	url: '/provider/finance/orderSettle/settleTime',
	data: data
})
// 供应商-财务-订单结算-结算验证
export const orderSettlesettleVerify = (data: any): any =>
request({
	url: '/provider/finance/orderSettle/settleVerify',
	data: data
})

// 供应商-财务-订单结算-结算信息
export const orderSettlesettleInfo = (data: any): any =>
request({
	url: '/provider/finance/orderSettle/settleInfo',
	data: data
})
// 供应商-财务-订单结算-结算
export const financeorderSettlesettle = (data: any): any =>
request({
	url: '/provider/finance/orderSettle/settle',
	data: data
})
// 供应商-财务-订单结算-售后明细
export const financeorderSettlesupportList = (data: any): any =>
request({
	url: '/provider/finance/orderSettle/supportList',
	data: data
})


// 获取发票列表
export const providerInvoiceproviderInvoicePageInit = (data: any): any =>
request({
	url: '/provider/providerInvoice/providerInvoicePageInit',
	data: data
})
// 发票下载
export const providerInvoiceproviderInvoiceDownLoad = (data: any): any =>
request({
	url: '/provider/providerInvoice/providerInvoiceDownLoad',
	data: data
})



// 获取商品供货商供货价
export const productproductProviderSupplyPrice = (data: any): any =>
request({
	url: '/provider/product/productProviderSupplyPrice',
	data: data
})
// 保存商品供货商供货价
export const productproductProviderSupplyPriceSave = (data: any): any =>
request({
	url: '/provider/product/productProviderSupplyPriceSave',
	data: data
})

// 分类-筛选框列表
export const productClassfilterBoxList = (data: any): any =>
request({
  url: '/provider/productClass/filterBoxList',
  data: data
})

// 排期商品列表
export const productscheduleProductList = (data: any): any =>
request({
  url: '/provider/product/scheduleProductList',
  data: data
})
// 申请排期商品
export const productapplyScheduleProduct = (data: any): any =>
request({
  url: '/provider/product/applyScheduleProduct',
  data: data
})
// 修改商品信息
export const productscheduleProductInfoEdit = (data: any): any =>
request({
  url: '/provider/product/scheduleProductInfoEdit',
  data: data
})
// 修改商品素材
export const productscheduleProductMaterialEdit = (data: any): any =>
request({
  url: '/provider/product/scheduleProductMaterialEdit',
  data: data
})
// 修改商品资质
export const productscheduleProductQualificationEdit = (data: any): any =>
request({
  url: '/provider/product/scheduleProductQualificationEdit',
  data: data
})
// 修改物流服务
export const productscheduleProductLogisticsServiceEdit = (data: any): any =>
request({
  url: '/provider/product/scheduleProductLogisticsServiceEdit',
  data: data
})
// 修改验仓
export const productscheduleProductCheckWarehouseEdit = (data: any): any =>
request({
  url: '/provider/product/scheduleProductCheckWarehouseEdit',
  data: data
})
// 导入商品规格编码数据
export const productproductSpecNoImport = (data: any): any =>
request({
	url: '/provider/product/productSpecNoImport',
	data: data
})

// 开票订单列表
export const orderorderInvoiceList = (data: any): any =>
request({
  url: '/provider/order/orderInvoiceList',
  data: data
})
// 上传发票
export const orderorderInvoiceUpload = (data: any): any =>
request({
  url: '/provider/order/orderInvoiceUpload',
  data: data
})
// 开票订单详情
export const orderorderInvoiceDetail = (data: any): any =>
request({
  url: '/provider/order/orderInvoiceDetail',
  data: data
})